export { default } from './SWRelatedArticles';
